const { $ } = window;

function parentParagraph(element) {
  const p = element.parent('p');
  p.css('position', 'relative');
  return p;
}

const firstCharIsCapitalized = (txt) =>
  txt.charAt(0) === txt.charAt(0).toUpperCase();
const emphasizedHtmlStr = (txt) =>
  firstCharIsCapitalized(txt)
    ? `<span>${txt}</span>`
    : `<span>...${txt}</span>`;

export default function emphasize() {
  return this.each((_i, element) => {
    const e = $(element);
    const emphasized = e.clone().addClass('pulled-quote');

    emphasized.html(emphasizedHtmlStr(e.text()));
    emphasized.prependTo(parentParagraph(e));
  });
}
